@if (asset && pdfJsUri) {
  <article class="viewerAsset viewerAssetDocument w-100 d-flex justify-content-center">
    <div class="w-75">
      <iframe #iframe id="pdfJsContainer" class="w-100 h-100 border-0" name="content-viewer" title="Content viewer"
      aria-label="Content viewer" tabindex="0" [src]="pdfJsUri"></iframe>
    </div>
  </article>
}
